import { AlertDialog, Button, Flex, Select, Text } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";
import { GlobeIcon } from "@radix-ui/react-icons";
import { useTranslation } from "react-i18next";
import { VideoPlaceholder } from "../../components/video-placeholde";

const langs = [
  { label: "English", value: "en" },
  { label: "Turkish", value: "tr" },
];

export function Start() {
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <div className="bg-tezzro-bg p-8 h-screen">
      <div className="relative bg-white border rounded-2xl border-card-border w-full h-full flex items-center justify-center">
        <div className="absolute top-4 right-5">
          <Select.Root
            value={lang}
            onValueChange={(value) => i18n.changeLanguage(value)}
            size="3"
          >
            <Select.Trigger variant="ghost" className="">
              <Flex align="center" gap="2">
                <GlobeIcon />
                {langs.find((item) => item.value === lang)?.label}
              </Flex>
            </Select.Trigger>
            <Select.Content position="popper">
              {langs.map((lang) => (
                <Select.Item value={lang.value} key={lang.value}>
                  {lang.label}
                </Select.Item>
              ))}
            </Select.Content>
          </Select.Root>
        </div>
        <div className="h-full">
          <div className="min-w-[400px] h-full">
            <div className="flex flex-col justify-center items-center h-full">
              <figure className="mb-6">
                <img
                  src="/autonomous-start.png"
                  className="object-contain max-w-[652px]"
                />
              </figure>
              <Text size="8" weight="bold" mb="7">
                {t("welcomeAutonomous")}{" "}
                <span className="inline-block animate-wave origin-[70%_70%] align-bottom">
                  <img className="w-[40px] h-[40px]" src="/waving-hand.png" />
                </span>
              </Text>
              <div className="flex gap-4">
                <AlertDialog.Root>
                  <AlertDialog.Trigger>
                    <Button size="4" radius="medium">
                      {t("start")}
                    </Button>
                  </AlertDialog.Trigger>
                  <AlertDialog.Content maxWidth="450px" className="!p-3">
                    <AlertDialog.Title size="6" align="center">
                      Confirm you and your family are in the checkout zone.
                    </AlertDialog.Title>
                    <Flex>
                      <figure>
                        <img src="/autonomous-confirmation.png" />
                      </figure>
                      <VideoPlaceholder className="aspect-square h-[calc(100vh-550px)] xl:max-h-[210px]" />
                    </Flex>

                    <Flex gap="3" mt="4" justify="end">
                      <AlertDialog.Cancel className="!grow">
                        <Button variant="soft" color="gray" size="4">
                          Cancel
                        </Button>
                      </AlertDialog.Cancel>
                      <AlertDialog.Action>
                        <Button
                          variant="solid"
                          size="4"
                          onClick={() => {
                            // const dateTime = "2024-09-15T10:43:56.215Z";
                            const dateTime = new Date().toISOString();
                            navigate(`checkout?checkout_datetime=${dateTime}`);
                          }}
                        >
                          Confirm & Proceed
                        </Button>
                      </AlertDialog.Action>
                    </Flex>
                  </AlertDialog.Content>
                </AlertDialog.Root>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
